import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import { movies } from '@/mocks/movies';

const hotList = movies.filter((m) => m.isHot).slice(0, 6);

export default function HotMovies() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">大家都在看的精彩内容</p>
        </div>
        <Link
          to="/category/movie"
          className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
        >
          查看更多
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
        {hotList.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}